module.exports = __webpack_public_path__ + "img/progressive-commission.f6a7ecf5.svg";